module.exports = __webpack_public_path__ + "static/media/treatment1.8f1814b6.png";